export default __webpack_public_path__ + "static/media/smooth.3007b9f5.svg";